import { IOption } from 'types/common'
import { IStep } from 'interfaces/step'

export function stepToOptions(steps: IStep[]): IOption<number>[] {
  const options: IOption<number>[] = Array.isArray(steps)
    ? steps?.map((step: IStep) => ({
        label: step.name,
        value: step.id
      }))
    : []

  return options
}

export function stepToOption(step: IStep): IOption<number> {
  return {
    label: step.name,
    value: step.id
  }
}
